import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import { Label, Input, Select, TextArea } from '~/componentes/CustomForm';
import CheckBox from "~/componentes/CustomForm/Check/styles/CheckBox";

import { Container, ThisCardAtividade } from './styles';
import CustomScrollBar from '~/componentes/CustomScrollBar';
import { Materialize } from '~/styles/materializeGrid';
import { SLModalFooter } from '~/pages/Sistema/componentes/SistemaList';
import ShowConfirmacao from '~/utils/ShowConfirmacao';
import Acoordion from '~/componentes/Acoordion';
import Button from '~/componentes/Button';
import IconLixeira from '~/assets/icones/IconLixeira.svg';

function CreateContent({ mountedData }) {
  const [clientes, setClientes] = useState([]);
  const [projetos, setProjetos] = useState([]);
  const [horarios, setHorarios] = useState([]);
  const [ordemServicoAtividades, setOrdemServicoAtividades] = useState([]);

  useEffect(() => {
    let lista = [];
    let listaHor = [];
    let count = 1;
    for (let itemAtv of mountedData?.atividades) {
      lista.push(itemAtv);

      for (const itemAtivo of itemAtv?.horarios) {
        listaHor.push({
          id: count,
          titulo: 'º Horário',
          horaInicial: itemAtivo?.horaInicial,
          horaFinal: itemAtivo?.horaFinal,
          idProjetoAtividade: itemAtv?.idProjetoAtividade,
        });

        count++;
      }
    }
    setOrdemServicoAtividades(lista);

    setHorarios(listaHor);

    setClientes([mountedData?.cliente]);
    setProjetos([mountedData?.projeto]);
  }, [mountedData]);

  return (
    <Container defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row">
          <div className="row">
            <div className="item col s12 m6 l8">
              <h5><span>#{mountedData?.id}</span> {mountedData?.titulo}</h5>
              <div className="item lateral row no-margin">
                <h5>Projeto: </h5>
                <p>{mountedData?.projeto?.titulo}</p>
              </div>
            </div>
            <div className="item col s12 m6 l3">
            </div>
            <div className="item lateral row no-margin">
              <h5>{((new Date(mountedData?.dataEmissao).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</h5>
            </div>
          </div>
          <div className="row no-margin">
            <div className="item col s3 m3 l3">
              <div className="item lateral row no-margin">
                <h5>Analista: </h5>
                <p>{mountedData?.analista?.nome}</p>
              </div>
              <div className="item lateral row no-margin">
                <h5>Hora Total: </h5>
                <p>{mountedData?.horaApontadaMascara}</p>
              </div>
            </div>
            <div className="item col s3 m3 l3">
              <div className="row no-margin">
                <div className="item lateral row no-margin">
                  <h5>Coordenador: </h5>
                  <p>{mountedData?.coordenador?.nome}</p>
                </div>
                <div className="item lateral row no-margin">
                  <h5>Hora Translado: </h5>
                  <p>{mountedData?.horaTransladoMacara}</p>
                </div>
              </div>
            </div>
            <div className="item col s3 m3 l3">
              <div className="row no-margin">
                <div className="item lateral row no-margin">
                  <h5>Cliente: </h5>
                  <p>{mountedData?.cliente?.nomeFantasia}</p>
                </div>
                <div className="item lateral row no-margin">
                  <h5>Hora Desconto: </h5>
                  <p>{mountedData?.horaDescontoMascara}</p>
                </div>
              </div>
            </div>
            <div className="item col s3 m3 l3">
              <div className="row no-margin">
                <div className="item lateral row no-margin">
                  <h5>Etapa: </h5>
                  <p>{mountedData?.descricaoStatusAprov}</p>
                </div>
                <div className="item lateral row no-margin">
                  <h5>Hora Total: </h5>
                  <p>{mountedData?.horaTotalMascara}</p>
                </div>
              </div>
            </div>
            <div className="item col s12 m12 l12">
              <div className="row no-margin">
                <div className="item lateral row no-margin">
                  <h5>Observação: </h5>
                  <p>{mountedData?.observacao}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="row no-margin list-atv">
            <div className="item col s12 m12 l12">
              <h5>Lista de Atividades: </h5>
            </div>
            <div className="item col s12 m12 l12">
              {mountedData?.atividades?.map((thisData, a) => (
                <ThisCardAtividade
                  className={'card-item'}
                  index={a}
                  ativo={true}
                >
                  <div className="top">
                    <div className="content-top">
                      <div className="card-top">
                        <p className="titulo">{thisData?.titulo}</p>
                        <p className="analista">{thisData?.descricao}</p>
                      </div>
                    </div>
                  </div>
                  <div className="content-os">
                    <div className="horario">
                      {thisData?.horarios?.map((thisHora, a) => (
                        <div className="item-hora">
                          <div className="card-numero">
                            <p className="numero">{a + 1}</p>
                          </div>
                          <div className="card-hora">
                            <p className="hora">{thisHora?.horaInicialMascara} - {thisHora?.horaFinalMascara}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="totalizadores">
                      <div className="card-total">
                        <p className="total">Total: {thisData?.horaTotalMascara}</p>
                      </div>
                    </div>
                  </div>
                </ThisCardAtividade>
              ))}
            </div>
          </div>
        </div>
      </Materialize>
    </Container>
  );
}

export default CreateContent;
